import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import { Payload } from 'stores'
import {
  createGenericSlice,
  GenericState,
  GetRejectValue,
} from 'stores/generics'
import {
  STORE_STATUS_INITIALIZED,
  STORE_BILL,
  STORE_BILL_FETCH,
  STORE_STATUS_LOADING,
  STORE_STATUS_FINISHED,
  STORE_STATUS_ERROR,
} from 'constants/store'
import { BillListPast, BillList, ErrorStore } from '@types'

export type State = GenericState<BillList>

export const initialState: State = {
  data: { bills: [], current_bill_id: '' },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

interface FetchListParameters {
  request: Promise<BillList | BillListPast>
  fetchNewCompany: boolean
}

export const fetchList = createAsyncThunk<
  BillList,
  FetchListParameters,
  Payload
>(
  STORE_BILL_FETCH,
  async ({ request, fetchNewCompany }, { rejectWithValue, getState }) => {
    try {
      const dataFromStore = getState().bill.list.data
      let billStore = { bills: [], current_bill_id: '' } as BillList
      if (!fetchNewCompany) {
        billStore = dataFromStore
      }
      const response = await request

      const billsRoot = [...response.bills, ...billStore.bills]
      const billsWithoutDuplicated = billsRoot.filter(
        (value, index, self) =>
          index ===
          self.findIndex((t) => t.id === value.id && t.id === value.id)
      )
      return { ...billStore, ...response, bills: billsWithoutDuplicated }
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers = (builder: ActionReducerMapBuilder<State>) => {
  builder.addCase(fetchList.pending, (state: State) => {
    state.status = STORE_STATUS_LOADING
  })
  builder.addCase(fetchList.fulfilled, (state: State, { payload }) => {
    state.error = null
    state.status = STORE_STATUS_FINISHED
    state.data = payload
  })
  builder.addCase(fetchList.rejected, (state: State, { payload }) => {
    const { code, message } = (payload || {}) as GetRejectValue
    state.data = initialState.data
    state.status = STORE_STATUS_ERROR
    state.error = {
      name: code,
      message: message,
    }
  })
}

const userSlice = createGenericSlice({
  name: STORE_BILL,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = userSlice

const { clear, success } = actions

export { clear, success }

export default reducer
